import { render, staticRenderFns } from "./CreationDate.vue?vue&type=template&id=63744b30&scoped=true"
import script from "./CreationDate.vue?vue&type=script&lang=js"
export * from "./CreationDate.vue?vue&type=script&lang=js"
import style0 from "./CreationDate.vue?vue&type=style&index=0&id=63744b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63744b30",
  null
  
)

export default component.exports